import * as React from 'react';

import { FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectProps } from '@mui/material/Select';

export type OptionItem = {
  label: React.ReactNode;
  value: string | number;
  disabled?: boolean;
};

type SelectOptionProps = {
  options: OptionItem[];
  error?: string;
  errorTouched?: boolean;
} & SelectProps;

export const SelectOptionV2: React.FC<SelectOptionProps> = ({
  name,
  id,
  label,
  options,
  fullWidth,
  error,
  errorTouched,
  ...restProps
}) => {
  return (
    <FormControl size='small' fullWidth={fullWidth} error={errorTouched && Boolean(error)}>
      <InputLabel id={`formik-${id}`}>{label}</InputLabel>
      <Select labelId={`formik-${id}`} label={label} name={name} {...restProps}>
        {options.map((x, i) => (
          <MenuItem key={i} value={x.value} disabled={x.disabled}>
            {x.label}
          </MenuItem>
        ))}
      </Select>
      {errorTouched && error && <FormHelperText sx={{ color: '#d32f2f' }}>{error}</FormHelperText>}
    </FormControl>
  );
};
